const newContainer = () => import("@/layouts/Default.vue");
const dailyWorkingList = () =>
  import("../views/daily-working/dailyWorkingList.vue");

export const cooperationRoutes: any[] = [
  {
    path: "/cooperation",
    name: "coopration",
    meta: {
      label: "خانه",
      requiresAuth: true,
      moduleName: "cooperation",
      redesigned: false,
    },
    component: newContainer,
    children: [
      {
        path: "order",
        name: "work_order",
        meta: {
          label: "سفارش کار",
          requiresAuth: true,
        },
        redirect: "/cooperation/order/search",
        // component: routerParent,
        children: [
          {
            path: "search",
            name: "search_order",
            // component: searchOrder,
            meta: {
              label: "لیست سفارش کار",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "payment-rule",
        name: "payment_rule",
        meta: {
          label: "حکم حقوقی",
          requiresAuth: true,
        },
        redirect: "/cooperation/payment-rule/search",
        // component: routerParent,
        children: [
          {
            path: "search",
            name: "search_payment_rule",
            // component: searchPaymentRule,
            meta: {
              label: "لیست احکام حقوقی",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "payment",
        name: "payment_cooperation",
        meta: {
          label: "پرداخت",
          requiresAuth: true,
        },
        redirect: "/cooperation/payment/search-parvandeh",
        // component: routerParent,
        children: [
          {
            path: "search-parvandeh",
            name: "search_payment_rule_parvandeh",
            // component: searchParvandeh,
            meta: {
              label: "صورت وضعیت همکاری",
              requiresAuth: true,
            },
          },
          {
            path: "search-payment/:parvandehCode",
            name: "search_payment",
            // component: searchPayment,
            meta: {
              label: "اسناد پرداخت",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "my-payment",
        name: "my-payment",
        meta: {
          label: "پرداخت‌های من",
          requiresAuth: true,
        },
        redirect: "/cooperation/my-payment/list",
        children: [
          {
            path: "my-payments",
            name: "my_payment_cooperation",
            meta: {
              label: "پرداخت‌های من",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "daily-working",
        name: "daily_working",
        meta: {
          label: "کارکرد روزانه",
          requiresAuth: true,
          redesigned: false,
        },
        redirect: "/cooperation/daily-working/list",
        children: [
          {
            path: "list",
            name: "daily-working-list",
            component: dailyWorkingList,
            meta: {
              label: "فهرست همکاری",
              requiresAuth: true,
              redesigned: false,
            },
          },
        ],
      },
    ],
  },
];
